export const CLAIMS_LOADING = 'CLAIMS_LOADING';
export const CLAIMS_LOADED = 'CLAIMS_LOADED';
export const CLAIM_LOADING = 'CLAIM_LOADING';
export const CLAIM_LOADED = 'CLAIM_LOADED';
export const PRICE_OFFER_SAVING = 'PRICE_OFFER_SAVING';
export const PRICE_OFFER_SAVED = 'PRICE_OFFER_SAVED';
export const SENT_PRICE_OFFERS_LOADING = 'SENT_PRICE_OFFERS_LOADING';
export const SENT_PRICE_OFFERS_LOADED = 'SENT_PRICE_OFFERS_LOADED';
export const NETWORKS_LOADING = 'NETWORKS_LOADING';
export const NETWORKS_LOADED = 'NETWORKS_LOADED';
export const PURCHASE_ORDERS_LOADING = 'PURCHASE_ORDERS_LOADING';
export const PURCHASE_ORDERS_LOADED = 'PURCHASE_ORDERS_LOADED';
export const SUBSCRIPTION_HISTORY_LOADING = 'SUBSCRIPTION_HISTORY_LOADING';
export const SUBSCRIPTION_HISTORY_LOADED = 'SUBSCRIPTION_HISTORY_LOADED';
export const STATS_OF_AUCTIONS_WITH_NO_SELLER_PARTICIPATION_LOADING = 'STATS_OF_AUCTIONS_WITH_NO_SELLER_PARTICIPATION_LOADING';
export const STATS_OF_AUCTIONS_WITH_NO_SELLER_PARTICIPATION_LOADED = 'STATS_OF_AUCTIONS_WITH_NO_SELLER_PARTICIPATION_LOADED';
export const SELLER_SENT_PRICE_OFFERS_LOADING = 'SELLER_SENT_PRICE_OFFERS_LOADING';
export const SELLER_SENT_PRICE_OFFERS_LOADED = 'SELLER_SENT_PRICE_OFFERS_LOADED';
export const CLAIM_LEAST_PRICE_OFFERS_SENT_BY_SELLER_LOADING = 'CLAIM_LEAST_PRICE_OFFERS_SENT_BY_SELLER_LOADING';
export const CLAIM_LEAST_PRICE_OFFERS_SENT_BY_SELLER_LOADED = 'CLAIM_LEAST_PRICE_OFFERS_SENT_BY_SELLER_LOADED';
export const TERMS_AND_CONDITIONS_LOADING = 'TERMS_AND_CONDITIONS_LOADING';
export const TERMS_AND_CONDITIONS_LOADED = 'TERMS_AND_CONDITIONS_LOADED';